exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/menu/common/potency-display/potency-display.scss
 ** module id = 95
 ** module chunks = 1 2 3 4 5 6 7 10 11 13 14 16 17 22 25 26 29 31 37 49 171
 **/